import { render, staticRenderFns } from "./mock.vue?vue&type=template&id=6b84e75a&scoped=true"
import script from "./mock.vue?vue&type=script&lang=js"
export * from "./mock.vue?vue&type=script&lang=js"
import style0 from "./mock.vue?vue&type=style&index=0&id=6b84e75a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b84e75a",
  null
  
)

export default component.exports